import * as Constants from './constants'

export const traHangListRequest = function traHangListRequest(formData) {
  return {
    type: Constants.TRAHANG_LIST_REQUESTING,
    payload: formData
  }
}

export const traHangListSuccess = function traHangListSuccess(data) {
  return {
    type: Constants.TRAHANG_LIST_SUCCESS,
    data
  }
}

export const traHangListError = function traHangListError(error) {
  return {
    type: Constants.TRAHANG_LIST_ERROR,
    error
  }
}

export const traHangDetailRequest = function traHangDetailRequest(formData) {
  return {
    type: Constants.TRAHANG_DETAIL_REQUESTING,
    payload: formData
  }
}

export const traHangDetailSuccess = function traHangDetailSuccess(data) {
  return {
    type: Constants.TRAHANG_DETAIL_SUCCESS,
    data
  }
}

export const traHangDetailError = function traHangDetailError(error) {
  return {
    type: Constants.TRAHANG_DETAIL_ERROR,
    error
  }
}

export const traHangUpdateRequest = (formData, callback) => {
  return {
    type: Constants.TRAHANG_UPDATE_REQUESTING,
    payload: formData,
    callback
  }
}

export const traHangUpdateSuccess = function traHangUpdateSuccess(response) {
  return {
    type: Constants.TRAHANG_UPDATE_SUCCESS,
    payload: response
  }
}

export const traHangUpdateError = function traHangUpdateError(error) {
  return {
    type: Constants.TRAHANG_UPDATE_ERROR,
    error
  }
}


// WEBPACK FOOTER //
// ./src/views/TraHang/actions.js